import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import './mainImage.scss';

export default ({ imageData }) => (
  <Img sizes={imageData.sizes} className="main-img-wrapper" />
);

// due to complexity of gatsby-image, styled-components did not work
// used standard style sheet



// WEBPACK FOOTER //
// ./src/components/MainImage/index.js